























import { Component, Prop, Vue } from 'vue-property-decorator';
import TipDialog from '@/components/checkout/TipDialog.vue';

@Component({
  components: { TipDialog },
})
export default class Tip extends Vue {
  @Prop() private tip!: number;

  private showDialog = false;

  private get otherValue(): number | false {
    return this.tip > 3 ? this.tip : false;
  }

  private onChange(newValue: number | undefined) {
    const value = newValue || 0;
    if (value !== this.tip) {
      this.$emit('selected', value);
    }
  }

  private onSave(value: number) {
    this.showDialog = false;
    this.onChange(value);
  }
}
